<template>
  <div>
    <!-- 添加新箱子 -->
    <el-dialog :title="$t('message.addNewChest')" :close-on-click-modal="false"
      :visible.sync="$parent.addBoxDialogVisible" width="480px" center>
      <div class="content">
        <!-- 添加新箱子 -->
        <div class="label">
          <span style="color:red">*</span>{{ $t("message.numberOfBoxes") }}
          ：
        </div>
        <div class="val">
          <el-input v-model="num" onfocus="this.select()"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.addBoxDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    order_sn: { type: String },
  },
  data() {
    return {
      num: "1",
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        order_sn: this.order_sn,
        num: this.num,
      };
      this.$api.inspectionApi.addBoxBatch(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.addBoxDialogVisible = false;
        this.$parent.uploadBoxList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>